<template>
  <div class="login">
    <div style="width:100%;text-align:center;">
      <h2 style="color:white" class="m-5">Keep track of...</h2>
      <div class="mt-5" style="color:white;">
        <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center;flex-wrap:wrap;padding:10px">
          <b-card title="Attendance" class="displaycard" >
            <b-card-text>
              <ol>
                <li></li>
                <li></li>
                <li></li>
              </ol>
            </b-card-text>
          </b-card>
          <b-card title="Gratitude" class="displaycard">
            <b-card-text>
              <ul>
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </b-card-text>
          </b-card>
          <b-card title="Books" class="displaycard">
            <b-card-text>
              <ul>
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </b-card-text>
          </b-card>
        </div>
      </div>
      <h2 style="color:white" class="m-5">...and more!</h2>
      <b-card title="" style="width:90%;border-radius:15px"  class="overflow-hidden">
        <h1>Create and share lists of things you want to keep track of. It's free!</h1>
        <b-card-body>
          <b-card-text>
            <em>Lists</em> gives you a beautiful page to share lists of items that you want to keep track of. Choose from bullets, numbered lists or to do items (to do coming soon!).
          </b-card-text>
          
          <h3 class="mt-4">What kind of lists will you create?</h3>
          <!-- <b-card-text>
            Check out the samples below:
          </b-card-text> -->
        </b-card-body>
        <!-- <b-list-group flush>
          <b-list-group-item>
            <h4>Be Serious</h4>
            Check out this shared list: <a href="https://listolinks.cabinetapps.com/u/thewilliam.id.blockstack/cc1506fb-4dc0-4255-9552-795c8e8e554c" target="_blank">Favorite Business Books of 2019</a>
          </b-list-group-item>
          <b-list-group-item>
            <h4>Be Inspirational</h4>
            Check out this shard list of <a href="https://listolinks.cabinetapps.com/u/thewilliam.id.blockstack/f732161e-c605-4de0-8b87-a44cb4737b0b" target="_blank">Inspirational Quotes</a>
          </b-list-group-item>
          <b-list-group-item>
            <h4>Be Silly</h4>
            Check out this shared list of <a href="https://listolinks.cabinetapps.com/u/thewilliam.id.blockstack/d49d7620-8a0c-4a0c-83a2-9b4ae47fea45" target="_blank">Famous Products with O' in the Name</a>
          </b-list-group-item>
        </b-list-group> -->

        <b-card-img :src="require('@/assets/images/santalistweb.jpg')" style="border-radius:15px;width:50%;padding:10px" class="mt-4" alt="Image" left></b-card-img>
      </b-card>
      <!-- <div style="color:white">
        <img src="@/assets/images/santalistweb.jpg" style="width: 500px; max-width:80%;" />
        <p style="font-size:10px">Santa image: <a href="http://www.freepik.com">Designed by Freepik</a></p>
      </div> -->
      <h2 style="color:white" class="m-5">Try it today!</h2>
      <b-button class="fe-pulse-w-pause" variant="light" @click="signIn">Sign in with Blockstack</b-button>

    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

export default {
  computed: {
    ...mapFields([
      'blockstack.user',
      'blockstack.userSession',
      'blockstack.user.username'
    ]),
  },
  created() {
    this.$store.dispatch('setUserSession')
  },
  mounted() {
    // this.$store.dispatch('nukeData')
    // console.log('Home Mounted')
    if (this.userSession.isUserSignedIn()) {
      // console.log("user is signed in");
      this.$store.dispatch('setUserProperties').then(() => {
        // this.$store.dispatch('load')
        // console.log('switching to lists...')
        this.$router.push('/lists')
      })
      
    } else if (userSession.isSignInPending()) {
      // console.log("signinpending")
      this.userSession.handlePendingSignIn().then(userData => {
        // console.log("user pending log in finished");
        // this.$store.dispatch('load')
        window.location = window.location.origin
        this.$router.push('/lists')
      });
    }

    // console.log("Login mounted routine finished...");
  },
  methods: {
    signIn() {
      this.$store.dispatch('signIn')
    }
  }
}
</script>

<style scoped>
.card {
  margin: 0 auto; /* Added */
  float: none; /* Added */
  margin-bottom: 10px; /* Added */
}

.displaycard {
  padding:10px;
  width: 100%;
  max-width:300px;
  color:black;
  text-align:left;
  border-radius:15px
}

@keyframes pulse {
  from { transform: scale(1); }
  50% { transform: scale(1.05); }
  to { transform: scale(1); }
}

.fe-pulse-w-pause {
  animation-name: pulse;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}
.fe-pulse-w-pause:hover,
.fe-pulse-w-pause:focus {
  animation-name: unset;
}
</style>